import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';
import { useNavigate } from 'react-router-dom';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    width: theme.marginBase * 6,
    height: theme.marginBase * 6,
    marginBottom: theme.marginBase * 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.borderRadius.std,
    backgroundColor: theme.colors.white,
    position: 'relative',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  icon: {
    fontSize: theme.iconSize.large,
    color: theme.colors.inkTertiary,
  },
  iconVerified: {
    color: theme.colors.greenAccessible,
  },
  bubbleContainer: {
    backgroundColor: theme.colors.greenMuted,
    position: 'absolute',
    width: theme.marginBase * 3,
    height: theme.marginBase * 3,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: -12,
    right: -12,
  },
  bubbleIcon: {
    fontSize: theme.iconSize.small,
    color: theme.colors.greenAccessible,
  },
}));

interface Props {
  icon: string;
  verified: boolean;
  link?: string;
}

export const VerifiedIcon = ({ icon, verified, link }: Props) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const navigateToLink = () => {
    if (link) {
      navigate(link);
    }
  };

  return (
    <div className={classes.container} onClick={navigateToLink}>
      <i
        className={classnames(icon, classes.icon, {
          [classes.iconVerified]: verified,
        })}
      />
      {verified && (
        <div className={classes.bubbleContainer}>
          <i className={classnames('ri-check-line', classes.bubbleIcon)} />
        </div>
      )}
    </div>
  );
};
